import { render, staticRenderFns } from "./RewardShow.vue?vue&type=template&id=54bc2d50&"
import script from "./RewardShow.vue?vue&type=script&setup=true&lang=js&"
export * from "./RewardShow.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RewardShow.vue?vue&type=style&index=0&id=54bc2d50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports